// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2a2NZ","title":"BackImages_title__2iu2H","images":"BackImages_images__1ivpR"};